import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MenuItemComponent } from './menu-item.component';

/**
 * @deprecated use `[riv-menu-item]` instead.
 * @see https://rivethealth.github.io/design-system/?path=/story/lib-modal-menu--example
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: '[deprecatedMenuItemLight]',
  styleUrls: ['./menu-item-light.component.scss'],
  templateUrl: './menu-item.component.html',
})
export class MenuItemLightComponent extends MenuItemComponent {}
